<script setup>
const props = defineProps({
    headline: {
        type: String,
        required: true,
    },
    copy: {
        type: String,
        required: true,
    },
    image: {
        type: Object,
        required: true,
    },
    button: {
        type: Object,
        required: true,
    },
    attributes: {
        type: Object,
        required: false
    }
});

</script>

<template>
    <section class="block block-image-text-cta" tabindex="-1">
        <div class="container">
            <div class='split-reverse'>
                <div class="image">
                    <MessImage :image="image" />
                </div>
                <div class='copy-box'>
                    <MessHtml v-if="headline" class="headline" tag="h2" :html="headline" />
                    <MessHtml v-if="copy" class="copy" :html="copy" />
                    <ProjectButton v-if="Object.keys(button).length" :button="button" class="button" outline color="var(--magenta)" />
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss">

.block-image-text-cta {
    color: var(--lavender);
    background-color: var(--magenta);
    background-image: url('@/assets/img/backgrounds/bubble-mag-5-small.png'), url('@/assets/img/backgrounds/bubble-mag-2-small.png');
    background-position: right top, left bottom;
    background-repeat: no-repeat, no-repeat;

    @media (min-width: $tablet) {
        background-image: url('@/assets/img/backgrounds/bubble-mag-5.png'), url('@/assets/img/backgrounds/bubble-mag-6.png');
        background-position: left top, right bottom;
    }

    .container {
        color: var(--lavender);
        border-radius: var(--radius);
        background-color: var(--magenta);

        @media (min-width: $tablet) {
            background-image: url('@/assets/img/backgrounds/bubble-mag-6-small.png');
            background-position: left bottom;
            background-repeat: no-repeat;
        }
    }

    .split-reverse {
        display: flex;
        flex-direction: column;
        gap: var(--box-padding-lr-m);
        
        @media (min-width: $tablet) {
            flex-direction: row;
            
            > div {
                width: 50%;
            }
            
            .copy-box {
                order: -1;
            }
        }
    }

    .headline {
        margin-bottom: var(--box-padding-tb-m);
        color: var(--cream);
    }

    .copy-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        padding: var(--box-padding-tb-m) var(--box-padding-lr-m);
    }

    .image {
        overflow: hidden;
        border-radius: var(--radius) var(--radius) 0 0;

        @media (min-width: $tablet) {
            border-radius: 0 var(--radius) var(--radius) 0;

            .mess-image:before {
                @include fakebox;
                background-image: url('@/assets/img/backgrounds/bubble-mag-5-small.png');
                background-position: right top;
                background-repeat: no-repeat;
                z-index: 1;
            }
        }

        .mess-image {
            height: 100%;
        }
    }

    .copy {
        margin-bottom: var(--box-padding-tb);
    }
}

</style>
